import defaultLayout from "@/layouts/side-nav-outer-toolbar";
import loadView from "../common/loadView";

export default [
  {
    path: "/comission/:mode/:id?",
    name: "comission",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Комиссия"
    },
    component: loadView("comission/comission-detail-view"),
  },
  {
    path: "/comissions",
    name: "comissions",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Комиссия"
    },
    component: loadView("comission/comissions-list-view"),
  },
];
